var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";

import Icon from "../Icon";
import styles from "./UserHeader.css";

var UserHeader = function (_Component) {
  _inherits(UserHeader, _Component);

  function UserHeader() {
    _classCallCheck(this, UserHeader);

    return _possibleConstructorReturn(this, (UserHeader.__proto__ || Object.getPrototypeOf(UserHeader)).apply(this, arguments));
  }

  _createClass(UserHeader, [{
    key: "render",
    value: function render() {
      var person = this.props.person;


      return React.createElement(
        "div",
        { className: styles.header },
        React.createElement(
          "div",
          { className: styles.content },
          person.avatar_url ? React.createElement("img", { src: person.avatar_url, alt: "Profile picture", className: styles.avatar }) : React.createElement(Icon, { name: "avatar", path: "img", description: "Avatar Placeholder", className: styles.avatar }),
          React.createElement(
            "div",
            { className: styles.displayName },
            person.display_name
          ),
          React.createElement(
            "div",
            { className: styles.bioContainer },
            React.createElement(
              "div",
              { className: styles.bio },
              person.bio_line
            ),
            person.social_profiles ? React.createElement(
              "div",
              { className: styles.socialIcons },
              person.social_profiles.facebook ? React.createElement(
                "a",
                { target: "_blank", href: person.social_profiles.facebook },
                React.createElement(Icon, { name: "facebook-inverse", path: "img", description: "facebook", className: styles.icon })
              ) : null,
              person.social_profiles.twitter ? React.createElement(
                "a",
                { target: "_blank", href: person.social_profiles.twitter },
                React.createElement(Icon, { name: "twitter-inverse", path: "img", description: "twitter", className: styles.icon })
              ) : null,
              person.social_profiles.linkedin ? React.createElement(
                "a",
                { target: "_blank", href: person.social_profiles.linkedin },
                React.createElement(Icon, { name: "linkedin-inverse", path: "img", description: "linkedin", className: styles.icon })
              ) : null,
              person.social_profiles.instagram ? React.createElement(
                "a",
                { target: "_blank", href: person.social_profiles.instagram },
                React.createElement(Icon, { name: "instagram-inverse", path: "img", description: "instagram", className: styles.icon })
              ) : null
            ) : null
          )
        )
      );
    }
  }]);

  return UserHeader;
}(Component);

UserHeader.propTypes = {
  person: PropTypes.object.isRequired
};

export default UserHeader;


// WEBPACK FOOTER //
// ./src/components/Library/UserHeader/UserHeader.js